var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 126,
    viewBox: "0 0 163 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.015 63.3531C152.015 72.0002 144.574 79.059 136.601 81.8826C128.628 84.7061 119.77 84.5296 111.265 85.412C102.761 86.2943 92.8393 94.059 86.8154 100.235C82.9175 104.294 80.9686 109.765 78.1338 114.706C75.2991 119.647 71.4012 124.412 65.9088 125.647C59.8849 126.883 53.6838 123 50.1404 118.059C46.5969 112.941 45.0023 106.765 43.2306 100.765C41.4588 94.7649 40.573 82.9414 36.3208 78.3531C32.6001 74.4708 27.6393 72.0002 22.8556 69.5296C18.0719 67.059 13.111 64.412 10.0991 60.0002C6.90993 55.5884 6.02406 49.2355 9.39036 45.0002C13.6425 39.7061 21.4382 40.412 28.1708 39.8826C40.7501 38.8237 52.4436 31.2355 58.8219 20.4708C61.1252 16.412 62.7197 12.0002 65.3773 7.94138C68.0349 4.05903 71.7556 0.529616 76.5393 0.000204407C83.0947 -0.705678 88.5871 4.58844 93.1936 9.35315C101.875 18.5296 110.202 30.1767 121.541 36.1767C132.703 42.1767 152.015 47.2943 152.015 63.3531Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.925 9.00006C159.102 9.70594 158.57 10.4118 158.039 10.5883L156.267 10.9412L156.622 12.7059C156.799 13.4118 156.267 14.1177 155.559 14.2942C154.85 14.4707 154.141 13.9412 154.141 13.2354L153.787 11.4707L152.015 11.8236C151.306 12.0001 150.598 11.4707 150.42 10.7648C150.243 10.0589 150.775 9.353 151.306 9.17653L153.078 8.82359L152.724 7.05889C152.547 6.353 153.078 5.64712 153.61 5.47065C154.318 5.29418 155.027 5.82359 155.204 6.353L155.559 8.11771L157.33 7.76477C158.039 7.76477 158.748 8.29418 158.925 9.00006Z",
    fill: "#FF681D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4531 90.5296C10.6303 91.2355 10.0987 91.9414 9.56722 92.1179L7.79548 92.4708L8.14983 94.2355C8.327 94.9414 7.79548 95.6473 7.08679 95.8238C6.37809 96.0002 5.6694 95.4708 5.49222 94.9414L5.13787 93.1767L3.36613 93.5296C2.65744 93.5296 1.94874 93.1767 1.77157 92.4708C1.5944 91.7649 2.12592 91.0591 2.65744 90.8826L4.42918 90.5296L4.07483 88.7649C3.89766 88.0591 4.42918 87.3532 4.9607 87.1767C5.6694 87.0002 6.37809 87.5296 6.55526 88.0591L7.08679 90.0002L8.85853 89.6473C9.56722 89.2943 10.2759 89.8238 10.4531 90.5296Z",
    fill: "#FF681D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9458 11.2941C15.7687 12 15.06 12.3529 14.3513 12.1765L12.5795 11.8235L12.2252 13.5882C12.048 14.2941 11.3393 14.8235 10.6306 14.6471C9.92193 14.4706 9.56758 13.7647 9.74475 13.0588L10.0991 11.2941L8.32736 10.9412C7.61867 10.7647 7.08715 10.0588 7.26432 9.35294C7.44149 8.64706 8.15019 8.29412 8.85888 8.29412L10.6306 8.82353L10.985 7.05882C11.1621 6.35294 11.8708 6 12.5795 6C13.2882 6.17647 13.6426 6.88235 13.6426 7.58824L13.2882 9.35294L15.06 9.70588C15.5915 9.88235 16.123 10.5882 15.9458 11.2941Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.584 120.176C102.407 120.882 101.698 121.235 100.989 121.235L99.2175 120.882L98.8631 122.647C98.686 123.353 97.9773 123.706 97.2686 123.706C96.5599 123.529 96.2055 122.824 96.2055 122.118L96.5599 120.353L94.7881 120C94.0794 119.824 93.7251 119.118 93.7251 118.412C93.9023 117.706 94.611 117.353 95.3197 117.353L97.0914 117.706L97.4457 115.941C97.6229 115.235 98.3316 114.882 99.0403 114.882C99.749 115.059 100.103 115.765 100.103 116.471L99.749 118.235L101.521 118.588C102.407 118.765 102.761 119.471 102.584 120.176Z",
    fill: "#E8F0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.255 109.941H161.228",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3564 109.941H143.688",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77197 109.941H29.5883",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.754 34.7646H14.7056V109.941H130.754V34.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6153 34.7646H14.7056V109.941H21.6153V34.7646Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7056 34.7645V22.941C14.7056 18.1763 18.6034 14.2939 23.3871 14.2939H122.25C127.034 14.2939 130.932 18.1763 130.932 22.941V34.7645H14.7056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7056 22.941V34.7645H22.6784V22.941C22.6784 18.1763 26.5762 14.2939 31.3599 14.2939H23.3871C18.6034 14.2939 14.7056 18.1763 14.7056 22.941Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.755 40.4114V95.9996L128.629 93.1761C128.451 93.1761 128.274 93.1761 128.097 93.1761C127.743 93.1761 127.388 93.1761 127.211 93.1761C125.439 92.9996 124.022 92.1173 122.959 90.7055L120.656 87.529C119.77 87.529 118.884 87.7055 118.175 87.7055C110.203 87.7055 102.407 83.8232 97.6232 77.4702C93.5482 71.9996 91.9536 65.2938 93.0166 58.7643C94.0797 52.0585 97.6232 46.2349 103.116 42.1761C107.545 38.9996 112.683 37.2349 118.175 37.2349C122.605 37.0585 127.034 38.2938 130.755 40.4114Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.474 109.941H14.7056V34.7646H130.754V109.941H45.0023",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7056 34.7645V22.941C14.7056 18.1763 18.6034 14.2939 23.3871 14.2939H122.25C127.034 14.2939 130.932 18.1763 130.932 22.941V34.7645H14.7056Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9543 24.5292C32.9543 27.1762 30.8282 29.1174 28.3477 29.1174C25.6901 29.1174 23.7412 26.9997 23.7412 24.5292C23.7412 21.8821 25.8673 19.9409 28.3477 19.9409C30.8282 19.9409 32.9543 22.0586 32.9543 24.5292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9544 24.5292C32.9544 26.9997 30.8283 29.1174 28.3479 29.1174C27.6392 29.1174 27.1077 28.9409 26.5762 28.7644C28.3479 28.0586 29.411 26.4703 29.411 24.5292C29.411 22.588 28.1707 20.9997 26.5762 20.2939C27.1077 20.1174 27.6392 19.9409 28.3479 19.9409C30.8283 19.9409 32.9544 22.0586 32.9544 24.5292Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9001 24.5292C48.9001 27.1762 46.774 29.1174 44.2935 29.1174C41.6359 29.1174 39.687 26.9997 39.687 24.5292C39.687 21.8821 41.8131 19.9409 44.2935 19.9409C46.774 19.9409 48.9001 22.0586 48.9001 24.5292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9002 24.5294C48.9002 26.9999 46.7741 29.1176 44.2937 29.1176C43.7622 29.1176 43.0535 28.9411 42.522 28.7646C44.2937 28.0588 45.5339 26.4705 45.5339 24.5294C45.5339 22.5882 44.2937 20.8235 42.522 20.1176C43.0535 19.9411 43.585 19.7646 44.2937 19.7646C46.7741 19.9411 48.9002 22.0588 48.9002 24.5294Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8458 24.5292C64.8458 27.1762 62.7198 29.1174 60.2393 29.1174C57.5817 29.1174 55.6328 26.9997 55.6328 24.5292C55.6328 21.8821 57.7589 19.9409 60.2393 19.9409C62.7198 19.9409 64.8458 22.0586 64.8458 24.5292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8456 24.5291C64.8456 26.9997 62.7195 29.1173 60.2391 29.1173C59.7076 29.1173 59.1761 28.9408 58.6445 28.7644C60.4163 28.0585 61.6565 26.4702 61.6565 24.3526C61.6565 22.4114 60.4163 20.6467 58.6445 19.9408C59.1761 19.7644 59.7076 19.5879 60.2391 19.5879C62.7195 19.9408 64.8456 22.0585 64.8456 24.5291Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9543 24.5292C32.9543 27.1762 30.8282 29.1174 28.3477 29.1174C25.6901 29.1174 23.7412 26.9997 23.7412 24.5292C23.7412 21.8821 25.8673 19.9409 28.3477 19.9409C30.8282 19.9409 32.9543 22.0586 32.9543 24.5292Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9001 24.5292C48.9001 27.1762 46.774 29.1174 44.2935 29.1174C41.6359 29.1174 39.687 26.9997 39.687 24.5292C39.687 21.8821 41.8131 19.9409 44.2935 19.9409C46.774 19.9409 48.9001 22.0586 48.9001 24.5292Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8458 24.5292C64.8458 27.1762 62.7198 29.1174 60.2393 29.1174C57.5817 29.1174 55.6328 26.9997 55.6328 24.5292C55.6328 21.8821 57.7589 19.9409 60.2393 19.9409C62.7198 19.9409 64.8458 22.0586 64.8458 24.5292Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.896 24.5293H73.1729",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8002 99.5293H47.8372C43.585 99.5293 40.9274 94.9411 43.0535 91.2352L68.035 48.1764C70.1611 44.4705 75.4763 44.4705 77.6024 48.1764L102.584 91.2352C104.71 94.9411 102.052 99.5293 97.8002 99.5293Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3623 79.4118C76.7166 75.5294 77.2482 66 77.6025 61.2353C77.7797 58.4118 75.6536 56.1177 72.8188 56.1177C69.984 56.1177 67.6808 58.5883 68.0351 61.2353C68.3895 66 68.921 75.353 69.2753 79.4118C69.4525 81.1765 71.0471 82.5883 72.8188 82.5883C74.5905 82.7647 76.1851 81.353 76.3623 79.4118Z",
    fill: "#FF681D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8309 89.1179C75.8309 90.8826 74.4135 92.2943 72.6418 92.2943C70.87 92.2943 69.4526 90.8826 69.4526 89.1179C69.4526 87.3532 70.87 85.9414 72.6418 85.9414C74.4135 86.1179 75.8309 87.5296 75.8309 89.1179Z",
    fill: "#FF681D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.322 100.235L128.982 85.0588L136.069 79.7646L147.408 94.9411C148.826 96.8823 148.472 99.7058 146.523 101.118C144.574 102.706 141.739 102.176 140.322 100.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.27 101.824C143.688 102.353 145.105 102.177 146.345 101.294C146.877 100.765 147.409 100.236 147.763 99.7061C146.877 100.059 145.814 99.8826 144.928 99.7061C144.042 99.3532 143.333 98.8238 142.802 98.1179L131.817 82.9414L128.982 85.0591L140.322 100.236C140.853 100.941 141.562 101.471 142.27 101.824Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.322 100.235L128.982 85.0588L136.069 79.7646L147.408 94.9411C148.826 96.8823 148.472 99.7058 146.523 101.118C144.574 102.706 141.739 102.176 140.322 100.235Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.16 87.8821L138.904 80.8233C139.613 80.2939 139.79 79.4115 139.258 78.7056L135.183 73.0586C133.589 74.8233 131.817 76.588 129.868 77.9998C127.742 79.588 125.439 80.8233 122.958 81.7056L127.033 87.5292C127.565 88.2351 128.451 88.4115 129.16 87.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.16 87.8821L138.904 80.8233C139.613 80.2939 139.79 79.4115 139.258 78.7056L135.183 73.0586C133.589 74.8233 131.817 76.588 129.868 77.9998C127.742 79.588 125.439 80.8233 122.958 81.7056L127.033 87.5292C127.565 88.2351 128.451 88.4115 129.16 87.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.16 87.8821L138.904 80.8233C139.613 80.2939 139.79 79.4115 139.258 78.7056L135.183 73.0586C133.589 74.8233 131.817 76.588 129.868 77.9998C127.742 79.588 125.439 80.8233 122.958 81.7056L127.033 87.5292C127.565 88.2351 128.451 88.4115 129.16 87.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.16 87.8821L138.904 80.8233C139.613 80.2939 139.79 79.4115 139.258 78.7056L135.183 73.0586C133.589 74.8233 131.817 76.588 129.868 77.9998C127.742 79.588 125.439 80.8233 122.958 81.7056L127.033 87.5292C127.565 88.2351 128.451 88.4115 129.16 87.8821Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.223 78.7057C139.259 71.9998 141.208 59.4704 134.475 50.4704C127.742 41.4704 115.163 39.5292 105.95 46.2351C96.737 52.941 94.9652 65.4704 101.698 74.4704C108.43 83.4704 121.187 85.2351 130.223 78.7057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.175 82.5882C129.428 82.5882 138.55 73.5023 138.55 62.2941C138.55 51.086 129.428 42 118.175 42C106.922 42 97.7998 51.086 97.7998 62.2941C97.7998 73.5023 106.922 82.5882 118.175 82.5882Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.908 73.765C125.262 74.6473 124.908 75.7061 124.022 76.0591C122.782 76.5885 121.541 76.9414 120.124 77.1179C119.238 77.2944 118.352 76.5885 118.175 75.5297C117.998 74.4708 118.707 73.5885 119.77 73.5885C120.833 73.412 121.719 73.2356 122.782 72.8826C123.49 72.3532 124.553 72.8826 124.908 73.765Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.88 64.5885C132.526 67.412 131.286 70.0591 129.337 72.1767C128.983 72.5296 128.628 72.7061 128.097 72.7061C127.565 72.7061 127.211 72.5296 126.679 72.1767C125.971 71.4708 125.794 70.412 126.502 69.7061C127.92 68.1179 128.805 66.1767 129.16 63.8826C129.691 60.8826 128.805 57.8826 127.034 55.412C124.73 52.2355 121.01 50.6473 117.112 50.8238C116.049 50.8238 115.34 50.1179 115.163 49.2355C115.163 48.3532 115.872 47.4708 116.758 47.2943C121.896 46.9414 126.679 49.2355 129.691 53.2944C132.526 56.6473 133.589 60.7061 132.88 64.5885Z",
    fill: "#FFF0E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 126,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/search-empty.5d863d33.svg";
export { ForwardRef as ReactComponent };